import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import elementsIds from '@/const/elementIds.json';
import { useOsService } from '@/services/OsService/OsService';
import { computed, inject } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { FeatureFlags } from '@/types/utils';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import sidemenuListWindows from './OS/sidemenu-list.windows.vue';
import sidemenuListLinux from './OS/sidemenu-list.linux.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'sidemenu-list',
  props: {
    miniState: { type: Boolean }
  },
  setup(__props: any) {

const osService = useOsService();


const coordinatorsService = inject(IKCoordinatorsService);
const GQL_CommonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));

const userRolePermissions = useUserRolePermissions();
const featureFlags = computed<FeatureFlags>(() => (GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags ? JSON.parse(GQL_CommonData?.result?.value?.ibManagerEntities?.featureFlags) : null));

return (_ctx: any,_cache: any) => {
  return (_unref(osService)?.isWindows.value)
    ? (_openBlock(), _createBlock(sidemenuListWindows, {
        key: 0,
        "data-testid": _unref(elementsIds).leftDrawer.listWindows,
        "feature-flags": _unref(featureFlags),
        "mini-state": __props.miniState,
        "user-role-permissions": _unref(userRolePermissions)
      }, null, 8, ["data-testid", "feature-flags", "mini-state", "user-role-permissions"]))
    : (_unref(osService)?.isUnix.value)
      ? (_openBlock(), _createBlock(sidemenuListLinux, {
          key: 1,
          "feature-flags": _unref(featureFlags),
          "data-testid": _unref(elementsIds).leftDrawer.listLinux,
          "mini-state": __props.miniState,
          "user-role-permissions": _unref(userRolePermissions)
        }, null, 8, ["feature-flags", "data-testid", "mini-state", "user-role-permissions"]))
      : _createCommentVNode("", true)
}
}

})